import { useQuery } from "@tanstack/react-query";
import { api, withClientTimeout } from "../lib/api";
import type { TaskRunTraceGraph } from "../../../shared/types";

export function useRunTrace(runId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["task-run-trace", runId],
    queryFn: () => {
      if (!runId) throw new Error("runId is required");
      return withClientTimeout((signal) => api.get<{ data: TaskRunTraceGraph }>(`/api/task-runs/${encodeURIComponent(runId)}/trace`, signal));
    },
    enabled: !!runId && enabled,
    staleTime: 10_000,
    retry: false,
  });
}
